<template>
	<div v-loading=loading>



    <el-tabs class='gPageBorder' v-model="activeName" @tab-click="handleClick">
      <!-- 暂时注释预警邮箱入口 20180129 by sing -->
      <!-- <el-tab-pane class='gForm' :label="$t('lin_global.yxpztitle')" name="first">
        <el-form ref="form" label-position="right" label-width="12.5%" style="">
          <el-form-item :label="$t('lin_global.yjyouxiang')" prop="name">
            <el-input></el-input>
          </el-form-item>
          <el-form-item>
            <el-button>{{$t('lin_global.chongzhi')}}</el-button>
            <el-button type="primary" @click="onCreate()">{{$t('lin_global.ljchangjian')}}</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane> -->

      <!-- <el-tab-pane :label="$t('lin_global.ympeizhi')" name="first">

        <el-form ref="setForm" class='gForm' :model="setForm" :rules="rules" label-position="right" label-width="12.5%" style="">
          <el-form-item :label="$t('lin_global.fwqdizhi')" prop="url">
            <el-input v-model = 'setForm.url'></el-input>
            <div style="color: #8391a5;font-size:12px;line-height: 2;margin-top: 4px;">{{$t('lin_global.fwqdztips')}}</div>

          </el-form-item>
          <el-form-item :label="$t('lin_global.fwqduankou')" prop="port">
            <el-input v-model = 'setForm.port'></el-input>
            <div style="color: #8391a5;font-size:12px;line-height: 2;margin-top: 4px;">{{$t('lin_global.duankoutips')}}</div>

          </el-form-item>
          <el-form-item :label="$t('terminal.details.animatType')" prop="type">
          <el-select v-model="value" @change="onChange" :placeholder="$t('lin_global.pselect')">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item v-if="this.value === '0'" :label="$t('lin_global.label_areaid')" prop="nisname">          
            <MechanismSelector :data="mechanismData"  :classs="'w_33'"></MechanismSelector>
          </el-form-item>
          <el-form-item v-if="this.value === '1'" :label="$t('lin_global.label_no')" prop="terno">            
            <AutoTerno @on-result-change="onDvInputChange"></AutoTerno>
          </el-form-item>

          <el-form-item v-if="this.value === '2'" :label="$t('app_mdFile')">

            <a class='aSc' :href="downUrl" :title="$t('app_downExp')" target="_blank">{{$t('app_downTplFile')}}</a>

            <el-upload
              class="upload-demo"
              name='fileUpload'
              :action="$fileExcelUlUrl"
              :before-upload="srcBefore"
              :on-success="srcSuccess"
              :file-list="srcList">
              <el-button size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item v-if="this.value === '2'" :label="$t('app_deviceNum')">
            <el-label style='width:25%;'>{{devices}}{{$t('app_amechine')}}</el-label>
          </el-form-item>

          <el-form-item>            
            <el-button type="primary" :loading="isSubmit" @click="onSave()">{{$t('lin_global.tuisongpeizhi')}}</el-button>
          </el-form-item>
        </el-form>

      </el-tab-pane> -->

      <el-tab-pane class='gForm' :label="'LOGO' + $t('app_setting')" name="second">
         <!--<el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">-->
         <el-form ref="ruleForm2" label-width="100px" class="demo-ruleForm">

          <el-form-item label="LOGO" prop="pass" style='width:100%;'>
                <el-upload
                  class="avatar-uploader"
                  :action="imgUploadUrl"
                  :show-file-list="false"
                  accept='image/*'
                  name="file"
                  style='background:none;'
                  :on-success="handleBgAvatarSuccess"
                  :before-upload="beforeBgAvatarUpload">
                  <div v-if="logo" style='background:#58B7FF;'>
                    <img :src="logo" style='height:96px;margin-top:16px;padding:0 16px 0 16px;background:none;'>
                  </div>
                  <div v-else style='width:400px;height:80px;line-height:80px;font-size:20px;color:#99A9BF;'>+</div>
                </el-upload>
                <label style='color:#99A9BF;'>{{$t('app_clickPicToUlPic')}}，200k {{$t('app_within')}}{{$t('app_pgsFormat')}}，{{$t('app_sgUseAndAdUse')}}</label>
          </el-form-item>

          <!-- <el-form-item>
            <el-checkbox v-if='logo' v-model="logoCheck">{{$t('app_useBigSize')}}
              <label style='color: #99A9BF'>({{$t('app_useBigSizeTip')}})</label>
            </el-checkbox>
            <el-checkbox v-else disabled v-model="logoCheck">{{$t('app_useBigSize')}}
              <label style='color: #99A9BF'>({{$t('app_useBigSizeTip')}})</label>
            </el-checkbox>
          </el-form-item> -->

          <el-form-item>
            <span v-if='logoValue'>
              <el-button  @click="cancelLogo">{{$t('app_cancel')}}</el-button>
              <el-button  type="primary" @click="saveLogo">{{$t('app_sureChange')}}</el-button>
            </span>
            <span v-else>
              <el-button disabled @click="cancelLogo">{{$t('app_cancel')}}</el-button>
              <el-button disabled type="primary" @click="saveLogo">{{$t('app_sureChange')}}</el-button>
            </span>


            <el-button @click="defaultLogo">{{$t('app_dfIcon')}}</el-button>
          </el-form-item>

        </el-form>
      </el-tab-pane>

      <!-- todo 多语言 -->
      <!-- <el-tab-pane class='gForm' :label="$t('lin_global.cs_config')" name="configData">
        <el-form label-position="right" label-width="14.5%" style="">
          <el-form-item :label="$t('app_hbsp') + '(' + ($t('app_minute')) + ')'" prop="name">
            
            <el-input-number v-model="terminalConfigForm.data.set.hb" controls-position="right" :min="1" :max="20"></el-input-number>
          </el-form-item>

          <el-form-item :label="$t('app_checkupsp') + '(' + $t('app_minute') + ')'" prop="name">
            
            <el-input-number v-model="terminalConfigForm.checkUpdateTime" controls-position="right" :min="terminalConfigForm.data.set.hb + 5" :max="120"></el-input-number>
          </el-form-item>

          <el-form-item :label="$t('app_rcmsg')">
            <el-checkbox-group v-model="terminalConfigForm.data.get">
              <el-checkbox label="l">{{$t('app_geo')}}</el-checkbox>
              <el-checkbox label="si">{{$t('app_sysinfo')}}</el-checkbox>
              <el-checkbox label="ts">{{$t('app_terstatus')}}</el-checkbox>
              <el-checkbox label="fi">{{$t('app_fminfo')}}</el-checkbox>
            </el-checkbox-group>

          </el-form-item>

          <el-form-item>
            
            <el-button type="primary" @click="saveTerminalConfig()">{{$t('app_save')}}</el-button>
          </el-form-item>

        </el-form>
      </el-tab-pane> -->
    </el-tabs>

    <div class='gTopMg gPageBorder' v-show="activeName === 'first'" style=''>
      <p class='gPTitle'>{{$t('lin_global.tuisongjl')}}</p>
      <el-table
        :data="arrdata"
        border
        style="width: 100%"
        ref="arrdata">
        <el-table-column
          prop="mechName"
          :label="$t('lin_global.label_areaid')">
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('lin_global.tuisonglx')"
          >
          <template slot-scope='scope'>
            <label>{{pushType(scope.row)}}</label>
          </template>
        </el-table-column>
        <el-table-column
          prop="successNum"
          :label="$t('lin_global.chenggong')">
        </el-table-column>
        <el-table-column
          prop="failNum"
          :label="$t('lin_global.shibai')">
        </el-table-column>
        <el-table-column
          prop="opeTime"
          :label="$t('lin_global.tuisongtime')">
        </el-table-column>
        <el-table-column
          width='80'
          align='center'
          :label="$t('lin_global.ope')">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="$t('lin_global.chongtui')" placement="top">
              <el-button v-if="scope.row.submit" @click="submitRow(scope.row.type,scope.row.config,scope.row.mechId,scope.row.terminalNo)" type="text"><i class="fa fa-rotate-right" style="color:#FF4949"></i>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="gPgDiv">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          class='gPg'
          :page-sizes="[10,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecords">
        </el-pagination>
      </div>
    </div>

	</div>

</template>

<script>
  import jq from 'jquery'
  import axios from 'axios'
  import { baseurl } from '../../api/url'
  import AutoTerno from '../global/TernoAutoCtrl'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import ElFormItem from "../../../node_modules/element-ui/packages/form/src/form-item.vue";

  export default{
    components: {
      ElFormItem,
      MechanismSelector, AutoTerno
    },
		data(){
      var that = this
			return {
        // 配置终端参数表单
        raw: '',
        terminalConfigForm: {
          checkUpdateTime: 0,
          pushTime: 20,
          data: {
            get: ['l'],
            set: {
              hb: 10
            }
          }
        },
        mechanismData: {
          placeholder: that.$t('lin_global.place_areaid'),
          callback (value) {
            that.value1 = value
//            that.cSelect(value)
          }
        },
        exInfo: '',
        devices: 0,
        srcList: [],
        isSubmit: false,
        logoCheck: false,
        oldLogo: '',
        loading: 0,
        logo: '',
        logoValue: '',
        activeName: 'second',
        isShow: false,
        options: [{
          value: '0',
            label:this.$t('lin_global.label_areaid')
        }, {
          value: '1',
          label: this.$t('lin_global.shebeibei')
        }, {
          value: '2',
          label: this.$t('app_fileImport')
        }],
        arrdata:[],
        currentPage: 1,
        pageSize: 10,
        totalRecords: 0,
        value: '0',
        value1: '',
        areaList1:[],
        setForm:{
          url: '',
          port:''
        },
        url: '',
        port:'',
        rules:{
            'url':[{
              type: 'string',
              required: true,
              message: this.$t('lin_global.fwqdzbnwk')
            }],
            'port':[{
              type: 'string',
              required: true,
              message: this.$t('lin_global.fwqdkhbnwk')
            }]
        }
      }
		},
    computed: {
      imgUploadUrl () {
        return this.$urls.picUrl
      },
      downUrl () {
        return this.$host + '/tms-server-web/model/terminalNos.xlsx'
      }
    },
		created(){
//      this.getAd1();
      this.getData(1);
		},
    watch : {
		  'terminalConfigForm.data.set.hb' (val, old) {
		    var that = this
        if (that.terminalConfigForm.checkUpdateTime < (val + 5)) {
          that.terminalConfigForm.checkUpdateTime = val + 5
        }
      }
    },
		methods:{
		  // 保存终端配置信息
      saveTerminalConfig () {
        var that = this
        //var a = {}
        //jq.extend(a, this.terminalConfigForm)
        //a.pushTime = a.pushTime * 1000 * 60
        var value = JSON.stringify(that.terminalConfigForm, null, 4)
        if (this.raw) {
          this.loading = true
          this.$setDvSetting(this.raw.id, value, (res) => {
            this.loading = false
            this.$message.success(res.message)
          }, (error) => {
            this.loading = false
            this.$message.error(this.$t('app_rqsError'))
          })
        } else {
          this.$message.error('error')
        }


      },
      onDvInputChange (vl) {
        this.value1 = vl
      },
      pushType (row) {
        switch (row.type) {
          case '0':
            return this.$t('app_distributor')
          break
          case '1':
            return this.$t('app_dv')
          break
          case '2':
            return this.$t('terminal.list.import_btn')
          break
        }
      },
      srcBefore (file) {
        // console.log(file)
        window[this.$route.path] = 1
        /*var name = file.name
        if (name === 'part0.zip') {
          window[this.$route.path] = 1
          return true
        } else {
          this.$message(this.$t('app_fileNameOnly') + 'part0.zip')
          return false
        } */
      },
      srcSuccess (res, file) {
        window[this.$route.path] = ''
        console.log('exres', res)
        if (res.status === 200) {
          this.srcList = [{name: file.name}]
          this.exInfo = res.data
          this.exInfo.file = file.name
          this.devices = res.data.terNums
          //this.hBlur('fm')
        } else {
          if (this.exInfo.file) {
            this.srcList = [{name: this.exInfo.file}]
          } else {
            this.srcList = []
          }
          this.$message.error(res.message)
        }
      },
      handleClick(tab, event) {
      },
      defaultLogo () {
        this.loading = 1
        this.$editLogo(localStorage.mechanismId, '', (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
            this.$store.dispatch('setHomeLogo', 'null')
            localStorage.logo = 'null'
            this.oldLogo = 'null'
            this.cancelLogo()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      saveLogo () {
        if (!this.logoValue) {
          this.$message(this.$t('app_uploadPic'))
          return
        }

        var sizeVl = this.logoCheck ? 1 : 0
        console.log(sizeVl)

        this.loading = 1
        this.$editLogo(localStorage.mechanismId, this.logoValue, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
            this.oldLogo = this.logoValue
            localStorage.logo = this.oldLogo
            this.cancelLogo()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      cancelLogo () {
        this.logo = ''
        this.logoValue = ''
        this.$store.dispatch('setHomeLogo', this.oldLogo)
      },
      handleBgAvatarSuccess (res, file) {
        this.loading = 0
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.logoValue = res.data
          this.logo = URL.createObjectURL(file.raw)
          this.$store.dispatch('setHomeLogo', res.data)
        }
      },
      beforeBgAvatarUpload (file) {
        var size = file.size / 1024
        if (size > 200) {
          this.$message.error(this.$t('app_fileOver') + '200k')
          return false
        }
        this.loading = 1
        return true
      },
      formatStatus:function(row,column){
        return row.type == 0?this.$t('lin_global.label_areaid'):row.userStatus == 1?this.$t('lin_global.shebeibei'):'';
      },
			// 创建报警邮箱
      getAd1:function(){
        var params = {page:1,rows:10000};
        axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
          //console.log(res.data);
          var obj={
            'mechanismname':this.$t('lin_global.all_mechanism'),
            'mechanismid':''
          }
          this.areaList1 = res.data.data;

          this.areaList1.unshift(obj)
        })
      },
      onCreate () {

      },
      submitRow(type,config,mechId,terminalNo){
          var id = '';
          if(type==="0"){
              id = mechId;
          }else{
              id = terminalNo
          }
        var params = {targetType:type,targetId:id,conf:config};
        this.$confirm(this.$t('lin_global.wdct'), this.$t('lin_btn.tips'), {
          confirmButtonText:this.$t('lin_btn.confirm'),
          cancelButtonText: this.$t('lin_btn.cancel'),
          type: 'warning'
        }).then(() => {
        axios.post(`${baseurl}/sysConfig/setTmsServerConf.do`,params).then(res=>{
          //console.log("打印返回");
          //console.log(res.data);
          if(res.data.status == 200){
            this.$message.success(res.data.message);
          }else{
            this.$message.error(res.data.message);
          }

        })
        })
      },
      onChange (val) {
          //0也就是false显示渠道商
        this.value1 = '';
        if(val === '0'){
          this.isShow = false;
        }else{
          this.isShow = true;
        }
      },
      onSave(){
        this.$refs['setForm'].validate((valid)=>{

          if(valid){
            if (this.value === '2' && !this.exInfo) {
              this.$message.error(this.$t('app_plsUpl'))
              return
            }
            var host = this.setForm.url + ':' + this.setForm.port;
            var fn = this.exInfo.fileNo ? this.exInfo.fileNo : ''
            var params = {fileNo: fn, targetType:this.value,targetId:this.value1,conf:host}
            this.$confirm(this.$t('lin_global.tuisongtips') + '【' + host + '】', this.$t('lin_btn.tips'), {
              confirmButtonText: this.$t('lin_btn.confirm'),
              cancelButtonText: this.$t('lin_btn.cancel'),
              type: 'warning'
            }).then(() => {
              this.isSubmit = true;
              this.loading = 1
              axios.post(`${baseurl}/sysConfig/setTmsServerConf.do`,params).then(res=>{
              //console.log("打印返回");
            //console.log(res.data);
            if(res.data.status == 200){
              this.loading = 0
              this.$message.success(res.data.message);
              this.isSubmit = false;
            }else{
              this.loading = 0
              this.$message.error(res.data.message);
              this.isSubmit = false;
            }

          })
          }).catch(() => {
            this.loading = 0
            })
          }else{
            this.loading = 0
            this.$message.error(this.$t('lin_global.refs'))
          return false
        }
      })

      },
      handleSizeChange: function (val) {
        this.pageSize = val
        this.getData(this.currentPage)
        //console.log(`每页 ${val} 条`)
      },
      handleCurrentChange: function (val) {
        this.currentPage = val
        this.getData(this.currentPage)
        //console.log('当前页: ${val}')
      },
      getData:function(page){
        this.currentPage = page;
        var params = {page:page,rows:this.pageSize};
        //console.log("看看是何方参数");
        //console.log(params);
        axios.post(`${baseurl}/sysConfig/terConfigCount.do`,params).then(res=>{
          //console.log("打印返回ORM列表")
          console.log('his res', res.data);
          this.arrdata = res.data.data;
          this.totalRecords = res.data.total;
          for(var i = 0;i<res.data.data.length;i++){
            if(res.data.data[i].failNum > 0){
              res.data.data[i]['submit'] = true;
            }else{
              res.data.data[i]['submit'] = false;
            }
          }
        })
      }
		},
    mounted () { 
      this.oldLogo = localStorage.logo

      this.$getDvSetting((res) => {
        if (res.status === 200) {
          var data = res.data
          if (data.length > 0) {
            data = data[0]
            this.raw = data
            this.terminalConfigForm = JSON.parse(data.value)
            //console.log(this.raw)
          }
        } else {
           this.$message.error(res.message)
        }
      }, '')

    },
    beforeRouteLeave (to, from, next) {
      if (this.logo) {
        this.$showConfirm('', this.$t('app_logoLvTip'), this.$t('app_yes'), this.$t('app_no'), 'warning', () => {
            next()
            this.$store.dispatch('setHomeLogo', this.oldLogo)
          }, () => {
            // 取消
            return false
          })
      } else {
        next()
        this.$store.dispatch('setHomeLogo', this.oldLogo)
      }
    }
	}
</script>



// WEBPACK FOOTER //
// sysSetting.vue?81a31244